import React from 'react';
import {
  PointSymbolProps,
  CustomLayerProps,
} from '@nivo/line';

import { DataPoint, PHQData } from '../../../types';
import { INCOMPLETE_PHQ_Y_VALUE } from '../../../utils/constants';

export const SeverityLayer: React.FC<CustomLayerProps> = (refProps: CustomLayerProps) => {
  const { yScale } = refProps;
  return (
    <g>
      <rect
        y={yScale(25)}
        width="7px"
        height={yScale(-1) - yScale(25)}
        fill="#1F2E81"
        stroke="#1F2E81"
        strokeWidth="0"
        x="-7px"
      />
      <rect
        y={yScale(19)}
        width="7px"
        height={yScale(-1) - yScale(19)}
        fill="#384FAC"
        stroke="#384FAC"
        strokeWidth="0"
        x="-7px"
      />
      <rect
        y={yScale(14)}
        width="7px"
        height={yScale(-1) - yScale(14)}
        fill="#6C7FCF"
        stroke="#6C7FCF"
        strokeWidth="0"
        x="-7px"
      />
      <rect
        y={yScale(9)}
        width="7px"
        height={yScale(-1) - yScale(9)}
        fill="#ADBBF8"
        stroke="#ADBBF8"
        strokeWidth="0"
        x="-7px"
      />
      <rect
        y={yScale(4)}
        width="7px"
        height={yScale(-1) - yScale(4)}
        fill="#ADBBF8"
        stroke="#ADBBF8"
        strokeWidth="0"
        x="-7px"
      />
    </g>
  );
};

const calculateStrokeDashArray = (radius: number, strokeWidth: number, numberOfDashes: number): string => {
  const strokeUnit = (Math.PI * 4 * radius) / (numberOfDashes * strokeWidth);
  return `${strokeUnit * 2/3}, ${strokeUnit * 1/3}`;
};

type CustomSymbolCurriedType = (
  selectedPHQ: PHQData,
  dateScoreMap: Map<number, string | number>,
) => React.FC<PointSymbolProps>;

export const CustomSymbol: CustomSymbolCurriedType = (
  selectedPHQ: PHQData,
  dateScoreMap: Map<number, string | number>,
) => (pointProps: PointSymbolProps) => {
  const { size, borderWidth, datum: { x, y } } = pointProps;

  const selectedDate = new Date(selectedPHQ.completeTime);

  const datumDate = new Date(x);
  const isBoldPoint = ((datumDate && selectedDate) && (datumDate.getTime() === selectedDate.getTime()));
  const dataPointDisplay = dateScoreMap.get(datumDate.getTime());
  const assessmentIncomplete = y === INCOMPLETE_PHQ_Y_VALUE;

  return (
    <g style={{ cursor: 'pointer' }}>
      <text
        y={-size * 1.5}
        textAnchor="middle"
        fontSize={isBoldPoint ? '18px' : '14px'}
      >
        {dataPointDisplay}
      </text>
      <circle
        fill={isBoldPoint ? '#ADBBF8' : null}
        fillOpacity={!isBoldPoint ? '0' : null}
        r={size}
        strokeWidth={borderWidth}
        stroke="#384FAC"
        strokeDasharray={assessmentIncomplete ? calculateStrokeDashArray(size, borderWidth, 8) : null}
      />
    </g>
  );
};

type BottomLineLayerCurriedType = (
  dataPoints: DataPoint[]
) => React.FC<CustomLayerProps>;

export const BottomLineLayer: BottomLineLayerCurriedType = (
  dataPoints: DataPoint[],
) => (
  refProps: CustomLayerProps,
) => {
  const { yScale, xScale } = refProps;

  return (
    <g>
      <rect
        y={yScale(-1)}
        width={xScale(dataPoints[dataPoints.length - 1].x) + 7}
        height={yScale(-7) - yScale(-1)}
        fill="#FAFAFA"
        stroke="#FAFAFA"
        strokeWidth="0"
        x="-7px"
      />
      <rect
        y={yScale(-7)}
        x="-7px"
        width={xScale(dataPoints[dataPoints.length - 1].x) + 7}
        height="1px"
        fill="#DADADD"
      />
    </g>
  );
};
